// extracted by mini-css-extract-plugin
export var errorIcon = "_ot-1";
export var nameLogo = "_ot-0";